/**
 * Data utilities for orga network graph v2
 * Handles combining widget data with hardcoded graph data
 */

import graphData_v2 from "../data/graphData.js";

/**
 * Get combined graph data from hardcoded data and widget controls
 * @param {Element} containerElement - The graph container element
 * @returns {Object} Combined graph data with nodes and links
 */
export function getCombinedGraphData(containerElement) {
  // Get widget data from data attribute
  const componentElement = containerElement.closest('[g-component="OrgaNetworkGraphV2"]');
  const widgetImageNodes = componentElement?.getAttribute("data-image-nodes");

  // Parse and convert widget data to graph format
  let dynamicImageNodes = [];
  if (widgetImageNodes) {
    try {
      const parsedNodes = JSON.parse(widgetImageNodes);
      dynamicImageNodes = parsedNodes.map((n, i) => {
        // Generate unique ID from name
        const id = `widget_img_${n.name
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^a-z0-9_]/g, "")}_${i}`;

        return {
          id: id,
          name: n.name,
          group: parseInt(n.group) || 2,
          size: Math.floor(Math.random() * (50 - 40 + 1)) + 40, // 40-50 range like gen_nodeWithImageSize
          type: "img",
          quote: n.quote || "",
          quote_author: n.quote_author || "",
          quote_role: n.quote_role || "",
          url_quoteImg: n.quote_img?.url || "",
        };
      });
    } catch (e) {
      console.warn("Failed to parse widget image nodes:", e);
    }
  }

  // Combine hardcoded data with widget data
  const combinedNodes = [...graphData_v2.nodes, ...dynamicImageNodes];
  return { nodes: combinedNodes, links: [] };
}
